'use client'

import Link from 'next/link'
import { useEffect } from 'react'
import { BUSINESS } from '@/lib/constants'
import { TrackedLink } from '@/components/analytics/TrackedLink'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <main
      className="error-page container"
      style={{ maxWidth: 720, margin: '0 auto', padding: '120px 32px', textAlign: 'center' }}
    >
      <div
        className="mono"
        style={{
          fontSize: 11,
          letterSpacing: '0.2em',
          color: 'var(--accent-hot)',
          textTransform: 'uppercase',
          marginBottom: 16,
        }}
      >
        Error
      </div>
      <h1 className="display" style={{ fontSize: 'clamp(40px, 5vw, 72px)', margin: '0 0 16px' }}>
        Something went wrong
      </h1>
      <p style={{ fontSize: 17, lineHeight: 1.6, color: 'var(--muted)', marginBottom: 32 }}>
        We hit a snag loading this page. Try again, or call us directly. We&apos;re happy to help over the phone.
      </p>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
        <button onClick={reset} className="btn btn-primary" type="button">
          Try Again
        </button>
        <TrackedLink
          href={`tel:${BUSINESS.phone.replace(/\D/g, '')}`}
          location="inline"
          label="error_page_call"
          className="btn btn-secondary"
          style={{ textDecoration: 'none' }}
        >
          Call {BUSINESS.phone}
        </TrackedLink>
        <Link href="/" className="btn btn-secondary" style={{ textDecoration: 'none' }}>
          Return Home
        </Link>
      </div>
      {error.digest ? (
        <p className="mono" style={{ fontSize: 11, color: 'var(--muted)', marginTop: 32 }}>
          ref: {error.digest}
        </p>
      ) : null}
    </main>
  )
}
